export default __webpack_public_path__ + "static/image-05-480x298-8843578b77a2c88bae55b3e3ef7ad351.jpg";